import { render, staticRenderFns } from "./start_class.vue?vue&type=template&id=5547d642&scoped=true&"
import script from "./start_class.vue?vue&type=script&lang=js&"
export * from "./start_class.vue?vue&type=script&lang=js&"
import style0 from "./start_class.vue?vue&type=style&index=0&id=5547d642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547d642",
  null
  
)

export default component.exports